import { topbarTokens } from '../Topbar/tokens';
import { BRAND_TURQUOISE } from '../../theme';

// Level palette — a categorical spectrum (amber → green → indigo → orchid →
// violet → teal → red) chosen so the seven capacity levels are clearly distinct
// from EACH OTHER, while keeping the tints (the band fills) light/pastel so the
// darker, saturated marks drawn on top read on any band:
//   — the dashboard's employee dots are emerald (high potential) and blue (standard);
//   — the report's candidate trace/dot is brand navy blue;
//   — the reference curves are green.
// Mutual separation between bands comes from hue rotation rather than from going
// dark. Each band is a light `tint` fill plus a saturated `accent` bar on the
// left. The talent-distribution donut reuses that same per-level `tint` background
// fill, so a level reads as one colour across the capacity map and the donut.
const LEVEL_RAMP = {
    I:   { accent: '#E08A2E', tint: '#FEFAF5' }, // ámbar (operador)
    II:  { accent: '#5FAE6E', tint: '#ECF6EE' }, // verde claro
    III: { accent: '#4A57D4', tint: '#E9ECFA' }, // indigo
    IV:  { accent: '#B14CAD', tint: '#F8E9F7' }, // orchid
    V:   { accent: '#7C57D8', tint: '#F1EBFB' }, // violet
    VI:  { accent: '#3E7E83', tint: '#ECF4F4' }, // petróleo / teal
    VII: { accent: '#D83C3C', tint: '#FDF2F2' }, // red
};

// The pie only covers levels II..V.
const PIE_LEVELS = ['II', 'III', 'IV', 'V'];

// Blend a hex colour toward white by `amount` (0 = unchanged, 1 = white).
const soften = (hex, amount) => {
    const n = parseInt(hex.slice(1), 16);
    const r = (n >> 16) & 0xff;
    const g = (n >> 8) & 0xff;
    const b = n & 0xff;
    const mix = (c) => Math.round(c * (1 - amount) + 255 * amount);
    return `#${((1 << 24) + (mix(r) << 16) + (mix(g) << 8) + mix(b)).toString(16).slice(1)}`;
};

export const dashboardTokens = {
    ...topbarTokens,
    color: {
        ...topbarTokens.color,
        success: '#10B981',
        successSoft: '#ECFDF5',
        warning: '#F59E0B',
        // Potential is encoded with a high/low contrast pair kept deliberately
        // separate from the level palette: blue = standard, turquoise = high
        // potential. The turquoise comes from the brand palette (theme.js
        // `BRAND_TURQUOISE`) and matches the high-potential star in the results
        // table (Results/tokens.js `starOk`) so potential reads the same across views.
        hipo: BRAND_TURQUOISE,
        standard: '#2E86D6',
    },
    // Pie slice colours: the per-level `accent` softened a touch toward white, so the
    // donut sits between the saturated axis bar and the very light band fill — less
    // accentuated than the raw accent, closer to (but still firmer than) the chart bands.
    pieColors: PIE_LEVELS.map((roman) => soften(LEVEL_RAMP[roman].accent, 0.38)),
    // Jacques chart background bands (light tint fill + saturated accent bar on the
    // left), keyed by roman level (I..VII).
    jacquesGroups: LEVEL_RAMP,
};
